import React from "react";

const ContactStageSkeleton = ({ rows = 4 }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <div className="radioBtnCont skeletonRow" key={`stageSkeleton${i}`}>
        <span className="linear-background skeletonRadio" />
        <span className="linear-background skeletonLabel" />
      </div>
    ))}
  </>
);

export default ContactStageSkeleton;
